import { usePreviewMode } from "datasets/hooks/usePreviewMode";
import { DatasetAccessLevel } from "datasets/types/enums/access-level";
import { Badge } from "~/components/ui/badge";

const ACCESS_LEVEL_LABEL: Record<DatasetAccessLevel, string> = {
  [DatasetAccessLevel.OWNER]: "Owner",
  [DatasetAccessLevel.ANALYZE]: "Analyst",
  [DatasetAccessLevel.PREVIEW]: "Preview",
};

interface AccessLevelBadgeProps {
  accessLevel: DatasetAccessLevel | null;
}

export function AccessLevelBadge({ accessLevel }: AccessLevelBadgeProps) {
  const isPreviewModeEnabled = usePreviewMode();

  if (!accessLevel) {
    return null;
  }

  const isVisible =
    accessLevel === DatasetAccessLevel.OWNER ||
    accessLevel === DatasetAccessLevel.ANALYZE ||
    (accessLevel === DatasetAccessLevel.PREVIEW && isPreviewModeEnabled);

  if (!isVisible) {
    return null;
  }

  return (
    <Badge variant="outline" className="rounded-full">
      {ACCESS_LEVEL_LABEL[accessLevel]}
    </Badge>
  );
}
